import type { ComponentPropsOptions, ExtractPublicPropTypes } from "vue";
import type { Size } from "@/components/helpers/types";
import { defineComponent } from "vue";
import { useCtx } from "@/composables/context";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";
import { formCtx } from "../form/Form";

const props = {
  id: p.string(() => {
    const suffix = Math.random().toString(36).slice(2, 11);
    return "legend-" + suffix;
  }),
  legend: p.$string(),
  name: p.string(),
  tooltip: p.string(),
  size: p.string<Size>("md"),
  legendClass: p.string(),
} satisfies ComponentPropsOptions;

export type FieldsetProps = ExtractPublicPropTypes<typeof props>;

export const fieldsetCtx = useCtx<FieldsetProps>();

export default defineComponent({
  name: "Fieldset",
  props,
  setup(props, { slots, attrs }) {
    const form = formCtx.inject({
      size: props.size,
    });

    fieldsetCtx.provide({
      ...props,
      size: form.size ?? props.size,
    });

    return () => (
      <fieldset class={cn("rounded border p-4", attrs.class ?? "")}>
        <legend class={cn("mb-1 px-1 text-[13px] text-foreground", props.legendClass)}>
          {props.legend}
        </legend>
        {slots.default?.()}
      </fieldset>
    );
  },
});
